import {AccountEmailResponse, AccountEmailResponseItem, BoarderDetailResponse} from "@/types/service-response";
import {AccountEmailItem} from "@/types";

export class AccountEmail {
    public constructor (
        readonly email: string,
        readonly isEdit?: boolean
    ) {}

    static createFromBoarderDetailResponse (responseData: BoarderDetailResponse): AccountEmail[] {
        return responseData.emails.map( (item: AccountEmailItem): AccountEmail =>
            new AccountEmail(
                item.email,
                false
            )
        )
    }

    static createFromResponse (responseData: AccountEmailResponse): AccountEmail[] {
        return responseData.map( (item: AccountEmailResponseItem): AccountEmail =>
            new AccountEmail(
                item.email,
                false
            )
        )
    }

    static createEmpty (): AccountEmail {
        return new AccountEmail(
            '',
            true
        )
    }

    public update? (isEdit: boolean): AccountEmail {
        return new AccountEmail(
            this.email,
            isEdit
        )
    }
}

